import { isStreamingAdvisoryEnabled, isStreamingEnabled } from './isStreamingEnabled.tsx';

export const useIsStreamingEnabled = (): boolean => {
	return isStreamingEnabled();
};

export const useIsStreamingAdvisoryEnabled = (): boolean => {
	return isStreamingAdvisoryEnabled();
};
